import { Checkbox as MuiCheckbox } from "@mui/material";
import { noop } from "../../utils";

export default ({
  value,
  onChange = noop,
  disabled,
  label, // eslint-disable-line no-unused-vars
  fullWidth, // eslint-disable-line no-unused-vars
  style, // eslint-disable-line no-unused-vars
  component, // eslint-disable-line no-unused-vars
  children, // eslint-disable-line no-unused-vars
  helpEnum, // eslint-disable-line no-unused-vars
  noIcon, // eslint-disable-line no-unused-vars
  ...rest
}) => (
  <div className="croField croField--checkbox">
    <MuiCheckbox
      checked={!!value}
      onChange={disabled ? noop : (e) => onChange(e.target.checked)}
      disabled={disabled}
      size="small"
      {...rest}
    />
  </div>
);

export const ReduxCheckbox = ({
  input: { value, onChange = noop },
  meta, // eslint-disable-line no-unused-vars
  fullWidth, // eslint-disable-line no-unused-vars
  disabled,
  component, // eslint-disable-line no-unused-vars
  children, // eslint-disable-line no-unused-vars
  helpEnum, // eslint-disable-line no-unused-vars
  noIcon, // eslint-disable-line no-unused-vars
  label, // eslint-disable-line no-unused-vars
  ...rest
}) => (
  <div className="croField croField--checkbox">
    <MuiCheckbox
      checked={value === "" ? false : !!value}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      size="small"
      {...rest}
    />
  </div>
);
